const SET_USER = "SET_USER";
const SET_USER_LIST = "SET_USER_LIST";

export const setUser = (payload) => ({
    type: SET_USER,
    payload,
});

export const setUserList = (userList) => {
    return {
        type: SET_USER_LIST,
        userList,
    };
};

const initialState = {
    currentUser: undefined,
    userList: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_USER:
            if (!action.payload) {
                return {
                    ...initialState,
                };
            }
            return {
                ...state,
                currentUser: {
                    ...action.payload,
                },
            };
        case SET_USER_LIST:
            return {
                ...state,
                userList: action.userList,
            };
        default:
            return state;
    }
};
